import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { billingApi } from "@/lib/api-client";

export default function PaymentResult({ mode }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(mode === "cancel" ? "cancelled" : "polling");
  const [tier, setTier] = useState(null);
  const tries = useRef(0);

  useEffect(() => {
    if (mode === "cancel" || !sessionId) return;
    let stop = false;
    const poll = async () => {
      if (stop || tries.current > 12) { if (!stop) setState("timeout"); return; }
      tries.current += 1;
      try {
        const r = await billingApi.status(sessionId);
        if (r.payment_status === "paid") { setTier(r.tier); setState("paid"); return; }
        if (["failed", "expired"].includes(r.payment_status)) { setState("failed"); return; }
      } catch (e) { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId, mode]);

  return (
    <div className="min-h-screen uc-grain flex items-center justify-center" data-testid="payment-result-page">
      <div className="border border-white/10 bg-black/50 p-10 text-center max-w-md">
        {state === "polling" && (<>
          <Loader2 size={40} className="animate-spin text-amber-400 mx-auto mb-4" />
          <div className="text-white text-lg">Confirming payment with Stripe…</div>
          <div className="text-white/40 text-xs mt-2 font-mono-uc uppercase">Do not close this window</div>
        </>)}
        {state === "paid" && (<>
          <CheckCircle2 size={40} className="text-emerald-300 mx-auto mb-4" />
          <div className="text-white text-lg" data-testid="payment-success-msg">
            Subscription active{tier ? ` — ${tier.toUpperCase()} TIER` : ""}
          </div>
          <Link to="/" className="uc-chip inline-flex mt-6 hover:bg-white/5" data-testid="payment-success-dashboard-btn">
            Enter Command Dashboard →
          </Link>
        </>)}
        {["failed", "timeout", "cancelled"].includes(state) && (<>
          <XCircle size={40} className="text-rose-400 mx-auto mb-4" />
          <div className="text-white text-lg" data-testid="payment-fail-msg">
            {state === "cancelled" ? "Checkout cancelled" : state === "timeout" ? "Confirmation timed out — check Billing for status" : "Payment failed"}
          </div>
          <Link to="/billing" className="uc-chip inline-flex mt-6 hover:bg-white/5">← Back to Billing</Link>
        </>)}
      </div>
    </div>
  );
}
